import { toast } from "react-toastify";
import {
  addStatusToOrderItems,
  clearDexieTable,
  ClearEventStorage,
  customToast,
  deepClone,
  errorHandler,
  toEpochSeconds,
  updateEventDetailAIResponse,
} from "../../shared";
import { custom, failure, success } from "./utilities";
import i18next from "i18next";
import { eventBookingServices } from "../../services";
import { loginActions } from "./login.actions";
import CryptoJS from "crypto-js";
import {
  globalSystemConstants,
  eventBookingConstants,
  customerConstants,
  localStorageKeys,
  eventDetailsFields,
  messages,
  defaultEventSetupObject,
  ROUTES,
  DEXIE_TABLENAME,
  eventBookingParams,
} from "../../constants";
import {
  NavigateToPath,
  NavigateToPathWithGo,
  history,
  saveToLocalStorage,
  removeItemFromStorage,
} from "../../system";
const {
  CHECK_OUT,
  ADD_RECAPZ,
  EVENT_NAME,
  SET_CART_TAB,
  TOTAL_EVENTS,
  GET_SHOT_LIST,
  IS_EDIT_EVENT,
  GET_REEL_PRICE,
  IS_DRAFT_EVENT,
  SET_FORM_STATE,
  GET_EDIT_BRIEF,
  GET_REEL_TYPES,
  GET_EDIT_EVENT,
  SET_REEL_VALUES,
  LAST_ACTIVE_TAB,
  ADD_REEL_STATES,
  REQUEST_BOOKING,
  GET_DRAFT_EVENT,
  GET_RECAP_TYPES,
  SET_EDIT_EVENTS,
  GET_MISC_AMOUNTS,
  SET_DRAFT_EVENTS,
  ADD_RECAPZ_BACKUP,
  SELECTED_EVENT_ID,
  CURRENT_EVENT_TYPE,
  SET_IS_PROFILE_VIEW,
  EVENT_ALREADY_EXIST,
  SELECTED_SHUTTER_BS,
  SET_BULK_REEL_VALUES,
  SET_MISC_AMOUNTS_OLD,
  IS_SB_TIP_EXTEND_CART,
  USE_SAME_LOGO_FOR_ALL_RECAPS,
  GET_AVAILABLE_SHUTTER_BS,
  GET_EVENT_TYPE_SHOT_LIST,
  SET_IS_DRAFT_EVENT_ALLOWED,
  SET_BULK_EVENT_DETAIL_VALUES,
  GET_AVAILABLE_SHUTTERB,
  ASSIGN_SHUTTERB,
  NOTIFY_ADMIN_TO_ASSIGN_SHUTTERB,
  REGENERATE_EDIT_BRIEF,
  GET_TAX_FOR_LOCATION,
  BILLING_DETAILS,
  UPDATE_SHOT_LIST,
  UPDATE_RECAP_BRIEF,
} = eventBookingConstants;

const getShotList = (id) => {
  return (dispatch) => {
    dispatch(custom(GET_SHOT_LIST, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .getShotList(id)
      .then(
        (response) => {
          dispatch(custom(response, GET_SHOT_LIST));
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, GET_SHOT_LIST));
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_SHOT_LIST, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const getAvailableShutterBs = (data) => {
  return (dispatch) => {
    dispatch(
      custom(GET_AVAILABLE_SHUTTER_BS, globalSystemConstants.SPINNER_ACTIVATE)
    );
    eventBookingServices
      .getAvailableShutterBs(data)
      .then(
        (response) => {
          const updatedResponse = {
            ...response,
            items: addStatusToOrderItems(response?.items),
          };
          dispatch(success(updatedResponse, GET_AVAILABLE_SHUTTER_BS));
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, GET_AVAILABLE_SHUTTER_BS));
          if (
            error[0].includes(messages.NO_SHUTTERB_AVAILABLE_IN_THIS_LOCATION)
          ) {
            dispatch(custom(true, SET_IS_DRAFT_EVENT_ALLOWED));
          } else {
            dispatch(custom(false, SET_IS_DRAFT_EVENT_ALLOWED));
          }
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_AVAILABLE_SHUTTER_BS,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const setAvaliableShutterB = (data) => {
  return (dispatch) => {
    dispatch(success({ items: data }, GET_AVAILABLE_SHUTTER_BS));
  };
};

const loginAsAdmin = (isAuthenticated) => {
  return (dispatch) => {
    const url = window.location.search;
    const params = new URLSearchParams(url);
    let token = params.get("token");
    const decodedToken = decodeURIComponent(token);
    try {
      if (decodedToken !== "") {
        var bytes = CryptoJS.AES.decrypt(decodedToken, "my-secret-key@123");
        var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        if (!isAuthenticated) {
          dispatch(
            loginActions.login({
              userName: decryptedData.user.userName,
              password: `${process.env.REACT_APP_ADMIN_PASSWORD}`,
            })
          );
          localStorage.setItem(process.env.REACT_APP_PAYLOAD, decodedToken);
          const updatedPath = window.location.pathname.replace(
            `/${token}`,
            "/:token"
          );
          window.location.replace(updatedPath);
        }
      }
    } catch (e) {
      console.log("Error parsing decrypted data:", e);
    }
  };
};

const getEventTypeShotList = (body, eventId, formState) => {
  return (dispatch) => {
    dispatch(
      custom(GET_EVENT_TYPE_SHOT_LIST, globalSystemConstants.SPINNER_ACTIVATE)
    );
    eventBookingServices
      .getEventTypeShotList(body)
      .then(
        (response) => {
          const updatedFormState = updateEventDetailAIResponse({
            formState,
            eventId,
            eventType: eventDetailsFields.EVENT_TYPE,
            description: eventDetailsFields.DESCRIPTION,
            value: response.items,
          });
          dispatch(eventBookingActions.setFormState(updatedFormState));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_EVENT_TYPE_SHOT_LIST,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const setAddRecapz = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.ADD_RECAPZ, data);
    dispatch(custom(data, ADD_RECAPZ));
  };
};

// Set backup of AddRecapz in case of Edit Event
const setAddRecapzBackup = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.ADD_RECAPZ_BACKUP, data);
    dispatch(custom(data, ADD_RECAPZ_BACKUP));
  };
};

const setEventTypes = (data) => {
  return (dispatch) => {
    dispatch(success(data, GET_EVENT_TYPE_SHOT_LIST));
  };
};

const setFormState = (data) => {
  return (dispatch) => {
    const updatedData = data?.map((event) => {
      return {
        ...event,
        eventDate: toEpochSeconds(event.eventDate),
        eventStartTime: toEpochSeconds(event.eventStartTime),
        sbStartTime: toEpochSeconds(event.sbStartTime),
      };
    });
    saveToLocalStorage(localStorageKeys.DATA_TO_SEND, { Event: updatedData });
    dispatch(
      custom(data || [deepClone(defaultEventSetupObject)], SET_FORM_STATE)
    );
  };
};

const setDraftEvents = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.DRAFT_EVENTS, data);
    dispatch(custom(data || null, SET_DRAFT_EVENTS));
  };
};

// Set edit events list
const setEditEvents = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.EDIT_EVENTS, data);
    dispatch(custom(data || null, SET_EDIT_EVENTS));
  };
};

const setEventAlreadyExist = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.EVENT_ALREADY_EXIST, data);
    dispatch(custom(data, EVENT_ALREADY_EXIST));
  };
};

const setIsSBTipExtendCart = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.SHUTTERB_TIP_EXTEND_CART, data);
    dispatch(custom(data, IS_SB_TIP_EXTEND_CART));
  };
};

const setUseSameLogoForAllRecaps = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.USE_SAME_LOGO_FOR_ALL_RECAPS, data);
    dispatch(custom(data, USE_SAME_LOGO_FOR_ALL_RECAPS));
  };
};

const setCartTab = (isCartTab = true) => {
  return (dispatch) => {
    dispatch(custom(isCartTab, SET_CART_TAB));
  };
};

const setIsProfileViewShow = (isProfileView = false) => {
  return (dispatch) => {
    dispatch(custom(isProfileView, SET_IS_PROFILE_VIEW));
  };
};

const setSelectedShutterBz = (data) => {
  return (dispatch) => {
    dispatch(custom(data, SELECTED_SHUTTER_BS));
  };
};

const setSelectedEventId = (data) => {
  return (dispatch) => {
    dispatch(custom(data, SELECTED_EVENT_ID));
  };
};

const setCurrentEventType = (data) => {
  return (dispatch) => {
    dispatch(custom(data, CURRENT_EVENT_TYPE));
  };
};

const setEventName = (data) => {
  return (dispatch) => {
    dispatch(custom(data, EVENT_NAME));
  };
};

const setPreviousActiveTab = (data) => {
  return (dispatch) => {
    dispatch(custom(data, LAST_ACTIVE_TAB));
  };
};

const setRegenerateEditBriefs = (data) => {
  return (dispatch) => {
    dispatch(custom(data, REGENERATE_EDIT_BRIEF));
  };
};

const setIsDraftEvent = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.IS_DRAFT_EVENT, data);
    dispatch(custom(data, IS_DRAFT_EVENT));
  };
};

const setIsEditEvent = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.IS_EDIT_EVENT, data);
    dispatch(custom(data, IS_EDIT_EVENT));
  };
};

const checkOut = (data) => {
  return (dispatch) => {
    dispatch(custom(CHECK_OUT, globalSystemConstants.SPINNER_ACTIVATE));
    dispatch(
      custom(null, globalSystemConstants.LOADING_BUTTON_SPINNER_ACTIVATE)
    );
    eventBookingServices
      .checkOut(data)
      .then(
        (response) => {
          removeItemFromStorage(localStorageKeys.ADD_CANCELLED_RECAPZ);
          if (
            response.message === messages.EVENT_SUCCESSFULLY_SAVED_AS_DRAFT ||
            response.message === messages.EVENT_SUCCESSFULLY_SAVED
          ) {
            customToast(messages.SUBMIT_SUCCESSFULLY, toast.TYPE.SUCCESS);
            const id =
              response.message === messages.EVENT_SUCCESSFULLY_SAVED_AS_DRAFT
                ? eventBookingParams.DRAFT_EVENT
                : eventBookingParams.DISCOUNTED_EVENT;

            NavigateToPath(
              history,
              ROUTES.EVENT_THANK_YOU,
              response.message,
              id
            );
          } else if (response) {
            dispatch(custom(response, CHECK_OUT));
          }
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, CHECK_OUT));
        }
      )
      .finally(() => {
        dispatch(custom(CHECK_OUT, globalSystemConstants.SPINNER_DIACTIVATE));
        dispatch(
          custom(null, globalSystemConstants.LOADING_BUTTON_SPINNER_DEACTIVATE)
        );
      });
  };
};

const requestBooking = (data, orderItemGroupId, CheckoutStatus) => {
  return (dispatch) => {
    dispatch(custom(REQUEST_BOOKING, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .requestBooking(data, orderItemGroupId, CheckoutStatus)
      .then(
        (response) => {
          localStorage.removeItem("dataToSend");
          localStorage.removeItem("activeTab");
          localStorage.removeItem(eventBookingConstants.EVENT_DETAIL_STORED);
          dispatch(custom(response, REQUEST_BOOKING));
        },
        (error) => {
          Array.isArray(error)
            ? error[0]
              ? customToast(i18next.t(error[0]), toast.TYPE.ERROR)
              : customToast("Something went wrong", toast.TYPE.ERROR)
            : customToast(i18next.t(error), toast.TYPE.ERROR);
          localStorage.removeItem("dataToSend");
          localStorage.removeItem("activeTab");
          localStorage.removeItem(eventBookingConstants.EVENT_DETAIL_STORED);

          dispatch(failure(error, REQUEST_BOOKING));
        }
      )
      .finally(() => {
        dispatch(custom({}, SET_FORM_STATE));
        dispatch(custom([], SELECTED_SHUTTER_BS));
        dispatch(custom(false, SET_CART_TAB));
        dispatch(custom([], customerConstants.UPDATE_CUSTOMER_DASHBOARD_CART));
        dispatch(custom({}, SET_BULK_REEL_VALUES));
        dispatch(custom({}, SET_BULK_EVENT_DETAIL_VALUES));
        const tempToken = localStorage.getItem(process.env.REACT_APP_PAYLOAD);
        localStorage.clear();
        localStorage.setItem(process.env.REACT_APP_PAYLOAD, tempToken);
        dispatch(
          custom(REQUEST_BOOKING, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const getReelPrice = () => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .getReelPrice()
      .then(
        (response) => {
          dispatch(success(response, GET_REEL_PRICE));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const getMiscAmounts = () => {
  return (dispatch) => {
    dispatch(custom(GET_MISC_AMOUNTS, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .getMiscAmounts()
      .then(
        (response) => {
          dispatch(custom(response, GET_MISC_AMOUNTS));
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, GET_MISC_AMOUNTS));
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_MISC_AMOUNTS, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const getTaxForLocation = (locationInfo, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(GET_TAX_FOR_LOCATION, globalSystemConstants.SPINNER_ACTIVATE)
    );
    eventBookingServices
      .getTaxForLocation(locationInfo)
      .then(
        (response) => {
          dispatch(custom(response, GET_TAX_FOR_LOCATION));
          onSuccess();
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, GET_TAX_FOR_LOCATION));
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_TAX_FOR_LOCATION, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const setMiscAmountsOld = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.MISC_AMOUNTS_OLD, data);
    dispatch(custom(data, SET_MISC_AMOUNTS_OLD));
  };
};

const applyDiscount = (dateToSend, onResponseCallback) => {
  return (dispatch) => {
    dispatch(custom(GET_MISC_AMOUNTS, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .applyDiscount(dateToSend)
      .then(
        (response) => {
          onResponseCallback(response?.items, dateToSend.codeType);
          customToast(
            i18next.t("Discount successfully applied"),
            toast.TYPE.SUCCESS
          );
        },
        (error) => {
          onResponseCallback(null, dateToSend.codeType);
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_MISC_AMOUNTS, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};
const draftEventDetails = (dataObj) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .draftEventDetails(dataObj)
      .then(
        (response) => {
          customToast("Submitted successfully.", toast.TYPE.SUCCESS);
          NavigateToPathWithGo(history, "/draft-event-thank-you");
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        localStorage.removeItem("dataToSend");
        localStorage.removeItem("activeTab");
        localStorage.removeItem(customerConstants.DATA_TO_SEND_EXTEND_SB);
        localStorage.removeItem(customerConstants.NOT_NEW_EVENT);
        localStorage.removeItem(customerConstants.CART_PREVIOUS_SCREEN);
        localStorage.removeItem(eventBookingConstants.REEL_STORED);
        localStorage.removeItem(eventBookingConstants.EVENT_DETAIL_STORED);
        localStorage.removeItem(
          customerConstants.STORED_CUSTOMER_DASHBOARD_CART
        );
        localStorage.removeItem(customerConstants.STORED_EVENT_DETAILS);
        dispatch({
          type: customerConstants.UPDATE_CUSTOMER_DASHBOARD_CART,
          data: [],
        });
        dispatch(custom({}, SET_FORM_STATE));
        // dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const getDraftEvents = (eventGroupId, onResponseCallback) => {
  return (dispatch) => {
    dispatch(custom(GET_DRAFT_EVENT, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .getDraftEvents(eventGroupId)
      .then(
        (response) => {
          if (onResponseCallback) {
            onResponseCallback(response.items);
          }
        },
        (error) => {
          onResponseCallback(null);
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_DRAFT_EVENT, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const getReelTypes = () => {
  return (dispatch) => {
    dispatch(custom(GET_REEL_TYPES, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .getReelTypes()
      .then(
        (response) => {
          dispatch(custom(response, GET_REEL_TYPES));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_REEL_TYPES, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const uploadMusicFile = (formData, fileName) => {
  return (dispatch) => {
    dispatch(custom(null, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .uploadMusicFile(formData)
      .then(
        (response) => {
          console.log("response", response);
          // dispatch(success(response, UPLOAD_MUSIC_FILE));
          dispatch({
            type: SET_REEL_VALUES,
            data: {
              name: ADD_REEL_STATES.MUSIC_FILE,
              value: {
                filePath: response.items,
                preview: fileName,
              },
            },
          });
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(custom(null, globalSystemConstants.SPINNER_DIACTIVATE));
      });
  };
};

const getEditBrief = (data, onResponseCallback) => {
  return (dispatch) => {
    dispatch(custom(GET_EDIT_BRIEF, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .getEditBrief(data)
      .then(
        (response) => {
          if (onResponseCallback) {
            onResponseCallback(response.items);
          }
        },
        (error) => {
          onResponseCallback(null);
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_EDIT_BRIEF, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const getRecapTypes = () => {
  return (dispatch) => {
    dispatch(custom(GET_RECAP_TYPES, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .getRecapTypes()
      .then(
        (response) => {
          dispatch(success(response, GET_RECAP_TYPES));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_RECAP_TYPES, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

// get edit events list (Event booking form)
const getEditEvents = (eventGroupId, eventId, status, onResponseCallback) => {
  return (dispatch) => {
    dispatch(custom(GET_EDIT_EVENT, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .getEditEvents(eventGroupId, eventId, status)
      .then(
        (response) => {
          if (onResponseCallback) {
            onResponseCallback(response.items);
          }
        },
        (error) => {
          onResponseCallback(null);
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(GET_EDIT_EVENT, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

// set the current total number of events added so far for the eventGroupId
const setTotalEvents = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.TOTAL_EVENTS, data);
    dispatch(custom(data, TOTAL_EVENTS));
  };
};

const resetEventBooking = (isTipOrExtend = false) => {
  return async (dispatch) => {
    ClearEventStorage(isTipOrExtend);
    await clearDexieTable(DEXIE_TABLENAME.LOGOS);
    dispatch(custom([deepClone(defaultEventSetupObject)], SET_FORM_STATE));
    dispatch(custom([], ADD_RECAPZ));
    dispatch(custom(null, IS_DRAFT_EVENT));
    dispatch(custom(null, SET_DRAFT_EVENTS));
    dispatch(custom([], SET_EDIT_EVENTS));
    dispatch(custom(null, IS_EDIT_EVENT));
    dispatch(custom([], ADD_RECAPZ_BACKUP));
    dispatch(custom(1, TOTAL_EVENTS));
    dispatch(custom(null, BILLING_DETAILS));

    if (!isTipOrExtend) {
      dispatch(custom([], customerConstants.ADD_TO_CUSTOMER_DASHBOARD_CART));
      dispatch(custom(false, EVENT_ALREADY_EXIST));
    }
  };
};

const getAvailableShutterb = (eventId, token) => {
  return (dispatch) => {
    dispatch(
      custom(GET_AVAILABLE_SHUTTERB, globalSystemConstants.SPINNER_ACTIVATE)
    );
    eventBookingServices
      .getAvailableShutterb(eventId, token)
      .then(
        (response) => {
          dispatch(success(response, GET_AVAILABLE_SHUTTERB));
        },
        (error) => {
          errorHandler(error);
          dispatch(failure(error, GET_AVAILABLE_SHUTTERB));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            GET_AVAILABLE_SHUTTERB,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const assignShutterb = (data, setIsThankYouPageVisible) => {
  return (dispatch) => {
    dispatch(custom(ASSIGN_SHUTTERB, globalSystemConstants.SPINNER_ACTIVATE));
    eventBookingServices
      .assignShutterb(data)
      .then(
        (_response) => {
          setIsThankYouPageVisible(true);
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(ASSIGN_SHUTTERB, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const notifyAdminToAssignShutterb = (
  eventId,
  OrderItemId,
  setIsNotifyAdmin
) => {
  return (dispatch) => {
    dispatch(
      custom(
        NOTIFY_ADMIN_TO_ASSIGN_SHUTTERB,
        globalSystemConstants.SPINNER_ACTIVATE
      )
    );
    eventBookingServices
      .notifyAdminToAssignShutterb(eventId, OrderItemId)
      .then(
        (_response) => {
          setIsNotifyAdmin(true);
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            NOTIFY_ADMIN_TO_ASSIGN_SHUTTERB,
            globalSystemConstants.SPINNER_DIACTIVATE
          )
        );
      });
  };
};

const setBillingDetails = (data) => {
  return (dispatch) => {
    saveToLocalStorage(localStorageKeys.BILLING_DETAILS, data);
    dispatch(custom(data, BILLING_DETAILS));
  };
};

const updateShotList = (data) => {
  return (dispatch) => {
    dispatch(custom(UPDATE_SHOT_LIST, globalSystemConstants.SPINNER_ACTIVATE));
    return eventBookingServices
      .updateShotList(data)
      .then(
        (response) => {
          dispatch(success(response, UPDATE_SHOT_LIST));
          return response;
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(UPDATE_SHOT_LIST, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

const updateRecapBrief = (data) => {
  return (dispatch) => {
    dispatch(
      custom(UPDATE_RECAP_BRIEF, globalSystemConstants.SPINNER_ACTIVATE)
    );
    return eventBookingServices
      .updateRecapBrief(data)
      .then(
        (response) => {
          dispatch(success(response, UPDATE_RECAP_BRIEF));
        },
        (error) => {
          errorHandler(error);
        }
      )
      .finally(() => {
        dispatch(
          custom(UPDATE_RECAP_BRIEF, globalSystemConstants.SPINNER_DIACTIVATE)
        );
      });
  };
};

export const eventBookingActions = {
  checkOut,
  setCartTab,
  getShotList,
  applyDiscount,
  setFormState,
  setEventName,
  getReelPrice,
  setAddRecapz,
  getEditBrief,
  getReelTypes,
  loginAsAdmin,
  setEventTypes,
  getRecapTypes,
  setEditEvents,
  getEditEvents,
  setTotalEvents,
  getMiscAmounts,
  requestBooking,
  getDraftEvents,
  setDraftEvents,
  setIsEditEvent,
  uploadMusicFile,
  setIsDraftEvent,
  setMiscAmountsOld,
  draftEventDetails,
  resetEventBooking,
  setAddRecapzBackup,
  setSelectedEventId,
  setCurrentEventType,
  setIsProfileViewShow,
  setSelectedShutterBz,
  getEventTypeShotList,
  setEventAlreadyExist,
  setIsSBTipExtendCart,
  setPreviousActiveTab,
  setAvaliableShutterB,
  getAvailableShutterBs,
  getAvailableShutterb,
  assignShutterb,
  notifyAdminToAssignShutterb,
  setRegenerateEditBriefs,
  setUseSameLogoForAllRecaps,
  getTaxForLocation,
  setBillingDetails,
  updateShotList,
  updateRecapBrief,
};
